var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;



//////////////////
// WEBPACK FOOTER
// ./~/victory-stack/~/lodash/_WeakMap.js
// module id = ./node_modules/victory-stack/node_modules/lodash/_WeakMap.js
// module chunks = 1